import "./../audit complet/simulation/simulation.css";
import { useState, useContext, useEffect, useCallback } from "react";
import {
  FaCogs,
  FaPrint,
  FaArrowLeft,
  FaSave,
  FaExclamationTriangle,
  FaUser,
  FaFileContract,
  FaMoneyBillWave,
  FaFileInvoiceDollar,
  FaBuilding,
  FaCoins,
  FaReceipt,
  FaPercentage,
  FaWallet,
  FaHandHoldingUsd,
  FaGlobe,
  FaPiggyBank,
  FaChartLine,
} from "react-icons/fa";
import Button from "components/ui/controls/button/button";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import { applyFormat } from "components/ui/ui-helpers";

// import Pager from "components/ui/controls/pager/pager";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import { AppContext } from "components/app/RemExprertProvider";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import TextField from "components/ui/controls/text-field/text-field";
import { ArbitragePptx } from "components/app/Api/Rapport/ApiRapport";
import { RemoveUnecessaryData } from "components/app/Api/ApiData";
import { Hover2 } from "components/ui/controls/hover/hover";
// import { useStudyManagementHandlers } from "pages/studyManagementHandler";
import { CompactFinancialCardThreeColumn } from "components/app/AuditRemuneration/Resultat/CompactFinancialCard";
import { Modal } from "@mui/material";
import { WarningMessage } from "components/ui/controls/info-message";
// import DetailTNSPageModal from "./detail/rémuneration/detailTNSPager";
// import DetailSalariePageModal from "./detail/rémunération/detailSalariePager";
// import DropDown from "components/ui/controls/drop-down/drop-down";
// import { AuditCompletWord } from "components/app/Api/Rapport/ApiRapport";

const RemExpressArbitragePage = (props) => {
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  // const [modalDetail, setModalDetail] = useState(false);
  const [modalSave, setModalSave] = useState(false);
  // const [modalOptimum, setModalOptimum] = useState(false);
  // const [modalChgtStatut, setModalChgtStatut] = useState(false);
  const Periode = context.state.OptiRemPeriodeActuelle === undefined ? undefined : context.state.OptiRemPeriodeActuelle[0];
  // const Prenom = context.state.Prenom;
  // const [circularWidth, setCircularWidth] = useState("0px");

  // États pour les calculs d'arbitrage
  const [arbitrage100Rem, setArbitrage100Rem] = useState({
    abattementMax: 0,
    enveloppe: 0,
    chargesSup: 0,
    prime: 0,
    resAvtIs: 0,
    is: 0,
    reserve: 0,
    divBruts: 0,
    regime: "PFU",
    revPercus: 0,
    remPercue: 0,
    autresRevenus: 0,
    impot: 0,
    cotFacPerso: 0,
    revDispo: 0,
    cotProductives: 0,
  });
  const [arbitrage100Div, setArbitrage100Div] = useState({
    enveloppe: 0,
    chargesSup: 0,
    prime: 0,
    resAvtIs: 0,
    is: 0,
    reserve: 0,
    divBruts: 0,
    regime: "PFU",
    revPercus: 0,
    remPercue: 0,
    autresRevenus: 0,
    impot: 0,
    cotFacPerso: 0,
    revDispo: 0,
    cotProductives: 0,
  });
  const [arbitrageOptimum, setArbitrageOptimum] = useState({
    enveloppe: 0,
    chargesSup: 0,
    prime: 0,
    resAvtIs: 0,
    is: 0,
    reserve: 0,
    divBruts: 0,
    regime: "PFU",
    revPercus: 0,
    remPercue: 0,
    autresRevenus: 0,
    impot: 0,
    cotFacPerso: 0,
    revDispo: 0,
    cotProductives: 0,
  });

  // Handlers pour la gestion des études
  // const studyHandlers = useStudyManagementHandlers(props);

  // Fonction pour sauvegarder les données dans l'iframe (similaire à la calculatrice)
  const sendToIframe = useCallback(
    ({ data }) => {
      if (data === "save") {
        let CleanData = RemoveUnecessaryData(context.state);
        delete CleanData.IdUser;
        delete CleanData.IdCabinet;
        let Resultat = {
          arbitrage100Rem,
          arbitrage100Div,
          arbitrageOptimum,
        };
        let evt = {
          Action: "save",
          DonneesMako: JSON.stringify(CleanData),
          Resultat: Resultat,
        };
        window.top.postMessage(evt, "*");
      }
    },
    [context.state, arbitrage100Rem, arbitrage100Div, arbitrageOptimum]
  );

  useEffect(() => {
    window.addEventListener("message", sendToIframe);
    return () => window.removeEventListener("message", sendToIframe);
  }, [sendToIframe]);

  useEffect(() => {
    // context.handleValueChange("OptiRemUnlockCoutEntreprise", true);
    // context.handleCalculOptiRem("cout_remuneration", "OptiRemCoutRemuneration", "", ResultatTNS,false, e);
    // context.handleCalculOptiRem("cout_entreprise", "OptiRemCoutEntreprise" + ClientConjoint, ClientConjoint, ResultatTNS, context.state["OptiRemCoutEntreprise" + ClientConjoint]);
  }, []);

  const handleCalculArbitrage = () => {
    context.handleValueChangeAsync("OptiRemOptionPfu", context.state.OptionPfu).then(() => {
      context.handleValueChangeAsync("OptiRemUnlockCoutEntreprise", true).then(() => {
        //AJOUT DE LA RESERVE
        context.handleValueChangeAsync("OptiRemReserve", context.state.ArbitrageReserve).then(() => {
          //CALCUL DU NOUVEAU RAI AVEC LA RESERVE
          context.handleCalculOptiRem("res_avant_is", "OptiRemResAvtIs", "", ResultatTNS, false, "0").then((result) => {
            const RaiArbitrage = Number(context.state.ArbitrageRai) - Number(result.Remuneration.ResAvtIs);
            const NewCoutRem = Number(context.state.RemExpressCoutRemuneration) + Number(RaiArbitrage);
            //100% PRIME
            context.handleCalculOptiRem("cout_remuneration", "OptiRemCoutRemuneration", "", ResultatTNS, false, NewCoutRem).then((result100Rem) => {
              console.log(result100Rem);
              let chargesSup = 0;
              if (Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel") {
                chargesSup =
                  Number(result100Rem.Remuneration.RemunerationClient.AffichageResultat.TotalChargesSociales) +
                  Number(result100Rem.Remuneration.RemunerationClient.AffichageResultat.CotisationsFacultativesEntreprise) -
                  Number(context.state.RemExpressCotisations);
              } else {
                chargesSup =
                  Number(result100Rem.Remuneration.RemunerationClient.AffichageResultat.TotalChargesPatronale) +
                  Number(result100Rem.Remuneration.RemunerationClient.AffichageResultat.TotalChargesSalariale) -
                  Number(context.state.RemExpressCotisations);
              }
              const abattementMax = Number(result100Rem.Impot.Dirigeant.AbattementMax);
              const prime = Number(result100Rem.Remuneration.RemunerationClient.AffichageResultat.RemunerationNette) - Number(context.state.RemExpressRemNette);
              const resAvtIs = Number(result100Rem.Remuneration.ResAvtIs);
              const is = Number(result100Rem.Remuneration.ImpotSoc);
              const reserve = Number(context.state.ArbitrageReserve) + Number(result100Rem.Remuneration.DivBrutsAutres);
              const divBruts = Number(result100Rem.Remuneration.DivBruts);
              const regime = context.state.OptionPfu === "oui" ? "PFU" : "Barème progressif";
              const revPercus = Number(result100Rem.Remuneration.RemunerationClient.AffichageResultat.RemunerationNette) + divBruts - Number(context.state.RemExpressRemNette);
              const remPercue = Number(context.state.RemExpressRemNette);
              const autresRevenus = Number(result100Rem.Impot.AutresRevenusFoyer);
              const impot = Number(result100Rem.Impot.IRTotal);
              const cotFacPerso = context.state.RemExpressCotFacPerso;
              const cotProductives =
                Number(result100Rem.Remuneration.RemunerationClient.Rapport.RetraiteObligatoire) +
                Number(result100Rem.Remuneration.RemunerationClient.Rapport.RetraiteFacultative) +
                Number(result100Rem.Remuneration.RemunerationClient.Rapport.TotalPEEProductif) +
                Number(result100Rem.Remuneration.RemunerationClient.Rapport.TotalPERCOProductif);
              const revDispo = revPercus + remPercue + autresRevenus - impot - cotFacPerso;
              setArbitrage100Rem({
                abattementMax: abattementMax,
                enveloppe: Number(context.state.ArbitrageRai),
                chargesSup: chargesSup,
                prime: prime,
                resAvtIs: resAvtIs,
                is: is,
                reserve: reserve,
                divBruts: divBruts,
                regime: regime,
                revPercus: revPercus,
                remPercue: remPercue,
                autresRevenus: autresRevenus,
                impot: impot,
                cotFacPerso: cotFacPerso,
                revDispo: revDispo,
                cotProductives: cotProductives,
              });
              //100% DIV
              context.handleValueChangeAsync("OptiRemUnlockCoutEntreprise", false).then(() => {
                console.log("PRO2", context.state.OptiRemResAvtIs);
                context
                  .handleCalculOptiRem(
                    Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel" ? "remuneration_nette" : "salaire_net",
                    "OptiRemRemNette",
                    "",
                    ResultatTNS,
                    false,
                    context.state.RemExpressRemNette
                  )
                  .then((result100Div) => {
                    let chargesSup = 0;
                    if (Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel") {
                      chargesSup =
                        Number(result100Div.Remuneration.RemunerationClient.AffichageResultat.TotalChargesSociales) +
                        Number(result100Div.Remuneration.RemunerationClient.AffichageResultat.CotisationsFacultativesEntreprise) -
                        Number(context.state.RemExpressCotisations);
                    } else {
                      chargesSup =
                        Number(result100Div.Remuneration.RemunerationClient.AffichageResultat.TotalChargesPatronale) +
                        Number(result100Div.Remuneration.RemunerationClient.AffichageResultat.TotalChargesSalariale) -
                        Number(context.state.RemExpressCotisations);
                    }

                    const prime = 0;
                    const resAvtIs = Number(result100Div.Remuneration.ResAvtIs);
                    const is = Number(result100Div.Remuneration.ImpotSoc);
                    const reserve = Number(context.state.ArbitrageReserve) + Number(result100Div.Remuneration.DivBrutsAutres);
                    const divBruts = Number(result100Div.Remuneration.DivBruts);
                    const regime = context.state.OptionPfu === "oui" ? "PFU" : "Barème progressif";
                    const revPercus = Number(result100Div.Remuneration.RemunerationClient.AffichageResultat.RemunerationNette) + divBruts - Number(context.state.RemExpressRemNette);
                    const remPercue = Number(context.state.RemExpressRemNette);
                    const autresRevenus = Number(result100Div.Impot.AutresRevenusFoyer);
                    const impot = Number(result100Div.Impot.IRTotal);
                    const cotFacPerso = context.state.RemExpressCotFacPerso;
                    const cotProductives =
                      Number(result100Div.Remuneration.RemunerationClient.Rapport.RetraiteObligatoire) +
                      Number(result100Div.Remuneration.RemunerationClient.Rapport.RetraiteFacultative) +
                      Number(result100Div.Remuneration.RemunerationClient.Rapport.TotalPEEProductif) +
                      Number(result100Div.Remuneration.RemunerationClient.Rapport.TotalPERCOProductif);
                    const revDispo = revPercus + remPercue + autresRevenus - impot - cotFacPerso;
                    setArbitrage100Div({
                      enveloppe: Number(context.state.ArbitrageRai),
                      chargesSup: chargesSup,
                      prime: prime,
                      resAvtIs: resAvtIs,
                      is: is,
                      reserve: reserve,
                      divBruts: divBruts,
                      regime: regime,
                      revPercus: revPercus,
                      remPercue: remPercue,
                      autresRevenus: autresRevenus,
                      impot: impot,
                      cotFacPerso: cotFacPerso,
                      revDispo: revDispo,
                      cotProductives: cotProductives,
                    });
                    context.handleValueChangeAsync("OptiRemChoixOptimum", "manu").then(() => {
                      context.handleValueChangeAsync("OptiRemOptimumRemMini", context.state.RemExpressRemNette).then(() => {
                        //OPTIMUM
                        context.handleCalculOptiRem("optimum", "", "", ResultatTNS, false, false).then((resultOptimum) => {
                          let chargesSup = 0;
                          if (Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel") {
                            chargesSup =
                              Number(resultOptimum.Remuneration.RemunerationClient.AffichageResultat.TotalChargesSociales) +
                              Number(resultOptimum.Remuneration.RemunerationClient.AffichageResultat.CotisationsFacultativesEntreprise) -
                              Number(context.state.RemExpressCotisations);
                          } else {
                            chargesSup =
                              Number(resultOptimum.Remuneration.RemunerationClient.AffichageResultat.TotalChargesPatronale) +
                              Number(resultOptimum.Remuneration.RemunerationClient.AffichageResultat.TotalChargesSalariale) -
                              Number(context.state.RemExpressCotisations);
                          }
                          const prime = Math.max(0, Number(resultOptimum.Remuneration.RemunerationClient.AffichageResultat.RemunerationNette) - Number(context.state.RemExpressRemNette));
                          const resAvtIs = Number(resultOptimum.Remuneration.ResAvtIs);
                          const is = Number(resultOptimum.Remuneration.ImpotSoc);
                          const reserve = Number(context.state.ArbitrageReserve) + Number(resultOptimum.Remuneration.DivBrutsAutres);
                          const divBruts = Number(resultOptimum.Remuneration.DivBruts);
                          const regime = resultOptimum.Remuneration.OptionPfu === "oui" ? "PFU" : "Barème progressif";
                          const revPercus = Number(resultOptimum.Remuneration.RemunerationClient.AffichageResultat.RemunerationNette) + divBruts - Number(context.state.RemExpressRemNette);
                          const remPercue = Number(context.state.RemExpressRemNette);
                          const autresRevenus = Number(resultOptimum.Impot.AutresRevenusFoyer);
                          const impot = Number(resultOptimum.Impot.IRTotal);
                          const cotFacPerso = context.state.RemExpressCotFacPerso;
                          const cotProductives =
                            Number(resultOptimum.Remuneration.RemunerationClient.Rapport.RetraiteObligatoire) +
                            Number(resultOptimum.Remuneration.RemunerationClient.Rapport.RetraiteFacultative) +
                            Number(resultOptimum.Remuneration.RemunerationClient.Rapport.TotalPEEProductif) +
                            Number(resultOptimum.Remuneration.RemunerationClient.Rapport.TotalPERCOProductif);
                          const revDispo = revPercus + remPercue + autresRevenus - impot - cotFacPerso;
                          setArbitrageOptimum({
                            enveloppe: Number(context.state.ArbitrageRai),
                            chargesSup: chargesSup,
                            prime: prime,
                            resAvtIs: resAvtIs,
                            is: is,
                            reserve: reserve,
                            divBruts: divBruts,
                            regime: regime,
                            revPercus: revPercus,
                            remPercue: remPercue,
                            autresRevenus: autresRevenus,
                            impot: impot,
                            cotFacPerso: cotFacPerso,
                            revDispo: revDispo,
                            cotProductives: cotProductives,
                          });
                        });
                      });
                    });
                  });
              });
            });
          });
        });
      });
    });
  };

  const HeaderThreeColumn = ({ libelle, icon, value1, value2, value3 }) => {
    return (
      <div className="resultat-header-card">
        <div className="resultat-header-card-content" style={{ flex: 1.5 }}>
          <div className="resultat-header-card-icon-container">{icon}</div>
          <span className="resultat-header-card-title">{libelle}</span>
        </div>
        {/* Valeurs en 3 colonnes alignées comme les autres lignes */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px", zIndex: 1, flex: 3 }}>
          {/* Colonne 1 - 100% Prime */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              flex: 0.8,
              padding: "6px 8px",
              borderRadius: "6px",
              background: "white",
              border: "1px solid #c6d4cdff",
            }}
          >
            <div
              style={{
                fontSize: "12px",
                fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                fontWeight: 400,
                color: "black",
                letterSpacing: "-0.02em",
                textAlign: "center",
              }}
              className="resultat-header-card-value"
            >
              {applyFormat(value1.toString() || 0, "uint", { thousands: " ", decimal: ",", unit: " €" })}
            </div>
          </div>

          {/* Colonne 2 - 100% Dividendes */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              flex: 0.8,
              padding: "6px 8px",
              background: "white",
              borderRadius: "6px",
              border: "1px solid #c6d4cdff",
            }}
          >
            <div
              style={{
                fontSize: "12px",
                fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                fontWeight: 400,
                color: "black",
                letterSpacing: "-0.02em",
                textAlign: "center",
              }}
              className="resultat-header-card-value"
            >
              {applyFormat(value2 || 0, "uint", { thousands: " ", decimal: ",", unit: " €" })}
            </div>
          </div>

          {/* Colonne 3 - Optimum */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              flex: 0.8,
              padding: "6px 8px",
              background: "white",
              borderRadius: "6px",
              border: "1px solid #c6d4cdff",
            }}
          >
            <div
              style={{
                fontSize: "12px",
                fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                fontWeight: 400,
                color: "black",
                letterSpacing: "-0.02em",
                textAlign: "center",
              }}
              className="resultat-header-card-value"
            >
              {applyFormat(value3 || 0, "uint", { thousands: " ", decimal: ",", unit: " €" })}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Column fill lpad>
        <Row>
          <div style={{ width: "1000px", maxWidth: "1000px" }}>
            <Row>
              <CardBox tpad rpad className="blockRoundedForceReduced">
                <Column fill rpad>
                  <Row tpad style={{ gap: "16px", alignItems: "flex-end" }}>
                    <TextField
                      label="Résultat avant IS"
                      value={context.state.ArbitrageRai}
                      onChange={context.handleInputChange("ArbitrageRai")}
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                      normal
                      style={{ flex: 1 }}
                      labelIcon={<FaChartLine />}
                    />
                    <TextField
                      label="Mise en réserve"
                      value={context.state.ArbitrageReserve}
                      onChange={context.handleInputChange("ArbitrageReserve")}
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                      normal
                      style={{ flex: 1 }}
                      labelIcon={<FaPiggyBank />}
                    />
                  </Row>
                  <WarningMessage
                    text={
                      <>
                        Nous vous rappelons que dans le cadre de la simulation, les charges sociales sont considérées comme provisionnées à la clôture de l'exercice et donc déductibles
                        fiscalement. Pour qu'elles le soient en pratique, il est indispensable que la distribution de dividendes intervienne avant la clôture de l'exercice en question. A titre
                        d'exemple, lorsqu'un arbitrage est réalisé en {new Date().getFullYear()}, il est indispensable que la distribution de dividendes intervienne avant la clôture de l'exercice {new Date().getFullYear()}. Le cas
                        échéant, les charges sociales générées par la distribution de dividendes ne pourront pas être déduites du résultat de l'exercice {new Date().getFullYear()}.
                      </>
                    }
                  />
                  {/* ActionButtons en grille 2x2 */}
                </Column>

                <Modal
                  width="450px"
                  height="25%"
                  title="Sauvegarde de la simulation"
                  icon={<FaSave />}
                  visible={modalSave}
                  onClose={() => {
                    setModalSave(false);
                  }}
                >
                  <Column fill>
                    <Row fill center>
                      <Column fill center>
                        <TextField
                          labelStyle={{ color: "var(--app-fg-color)" }}
                          label="Libellé de la simulation"
                          value={context.state.LibelleOptimisation}
                          onChange={context.handleInputChange("LibelleOptimisation")}
                          style={{ width: "370px" }}
                        />
                      </Column>
                    </Row>
                    <Row className="pager-buttons">
                      <Column fill>
                        <Button
                          onClick={() => {
                            // context.handleNewSimulation("Audit prévoyance");
                            context.handleSaveAsOptimisation(context.state.IdOptimisation, "OptiRem");
                            setModalSave(false);
                          }}
                        >
                          <span>Enregistrer</span>
                        </Button>
                      </Column>
                      <Column fill>
                        <Button
                          onClick={() => {
                            context.handleSaveAsOptimisation("", "OptiRem");
                            // context.handleNewSimulation("Audit prévoyance");
                            setModalSave(false);
                          }}
                        >
                          <span>Enregistrer sous</span>
                        </Button>
                      </Column>
                    </Row>
                  </Column>
                </Modal>
              </CardBox>
          <CardBox tpad lpad className="blockRoundedForceReduced">
            <Column >
              <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "20px" }}>
                <ActionButton
                  onClick={() => {
                    handleCalculArbitrage();
                  }}
                  icon={FaCogs}
                  title="Calculer"
                  subtitle="Lancer l'arbitrage"
                  colors={{
                    primary: "#3b82f6",
                    secondary: "#1d4ed8",
                    shadow: "rgba(59, 130, 246, 0.4)",
                    shadowHover: "rgba(59, 130, 246, 0.6)",
                  }}
                  decorativeIcon={{ type: "upload" }}
                  style={{ width: "180px" }}
                />
                <ActionButton
                  onClick={() => {
                    ArbitragePptx(context.state, arbitrage100Rem, arbitrage100Div, arbitrageOptimum).then((res) => {});
                  }}
                  icon={FaPrint}
                  title="Impression"
                  subtitle="Editer un pptx"
                  colors={{
                    primary: "#11998e",
                    secondary: "#0d7377",
                    shadow: "rgba(17, 153, 142, 0.4)",
                    shadowHover: "rgba(17, 153, 142, 0.6)",
                  }}
                  decorativeIcon={{ type: "document" }}
                  style={{ width: "180px" }}
                />
                <ActionButton
                  onClick={() => {
                    props.onClose();
                  }}
                  icon={FaArrowLeft}
                  title="Quitter"
                  subtitle="Revenir aux simulations"
                  colors={{
                    primary: "#e57373",
                    secondary: "#c62828",
                    shadow: "rgba(229, 115, 115, 0.4)",
                    shadowHover: "rgba(229, 115, 115, 0.6)",
                  }}
                  decorativeIcon={{ type: "previous" }}
                  style={{ width: "180px" }}
                />
              </div>
            </Column>

            <Modal
              width="450px"
              height="25%"
              title="Sauvegarde de la simulation"
              icon={<FaSave />}
              visible={modalSave}
              onClose={() => {
                setModalSave(false);
              }}
            >
              <Column fill>
                <Row fill center>
                  <Column fill center>
                    <TextField
                      labelStyle={{ color: "var(--app-fg-color)" }}
                      label="Libellé de la simulation"
                      value={context.state.LibelleOptimisation}
                      onChange={context.handleInputChange("LibelleOptimisation")}
                      style={{ width: "370px" }}
                    />
                  </Column>
                </Row>
                <Row className="pager-buttons">
                  <Column fill>
                    <Button
                      onClick={() => {
                        // context.handleNewSimulation("Audit prévoyance");
                        context.handleSaveAsOptimisation(context.state.IdOptimisation, "OptiRem");
                        setModalSave(false);
                      }}
                    >
                      <span>Enregistrer</span>
                    </Button>
                  </Column>
                  <Column fill>
                    <Button
                      onClick={() => {
                        context.handleSaveAsOptimisation("", "OptiRem");
                        // context.handleNewSimulation("Audit prévoyance");
                        setModalSave(false);
                      }}
                    >
                      <span>Enregistrer sous</span>
                    </Button>
                  </Column>
                </Row>
              </Column>
            </Modal>
          </CardBox>
            </Row>
          </div>
        </Row>

        {/* Section des résultats d'arbitrage */}
        <Row>
          <div
            style={{
              width: "1004px",
              maxWidth: "1004px",
              borderRadius: "16px",
            }}
          >
            {/* Titre de section */}

            {/* En-têtes des colonnes */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "16px",
                padding: "8px 12px",
                backgroundColor: "#f8fafc",
                borderRadius: "8px",
                border: "1px solid rgba(0,0,0,0.06)",
              }}
            >
              {/* Espace pour le libellé */}
              <div
                style={{
                  flex: 1.5,
                  fontSize: "12px",
                  fontWeight: 500,
                  color: "#6b7280",
                }}
              ></div>

              {/* Colonnes de titres alignées avec les données avec espacement */}
              <div style={{ display: "flex", flex: 3, gap: "8px" }}>
                <div
                  style={{
                    flex: 0.8,
                    textAlign: "center",
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#2563eb",
                    padding: "6px 8px",
                    backgroundColor: "#eff6ff",
                    border: "1px solid #dbeafe",
                    borderRadius: "6px",
                  }}
                >
                  100% Prime
                </div>
                <div
                  style={{
                    flex: 0.8,
                    textAlign: "center",
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#059669",
                    padding: "6px 8px",
                    backgroundColor: "#ecfdf5",
                    border: "1px solid #d1fae5",
                    borderRadius: "6px",
                  }}
                >
                  100% Dividendes
                </div>
                <div
                  style={{
                    flex: 0.8,
                    textAlign: "center",
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#dc2626",
                    padding: "6px 8px",
                    backgroundColor: "#fef2f2",
                    border: "1px solid #fecaca",
                    borderRadius: "6px",
                  }}
                >
                  Optimum
                </div>
              </div>
            </div>
            <HeaderThreeColumn
              libelle="Enveloppe entreprise"
              icon={<FaBuilding className="resultat-header-card-icon" />}
              value1={arbitrage100Rem.enveloppe}
              value2={arbitrage100Div.enveloppe}
              value3={arbitrageOptimum.enveloppe}
            />
            {/* Grille de cartes financières */}
            <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
              {/* Enveloppe entreprise - Style resultat.js avec 3 colonnes */}

              <div
                style={{
                  background: "#ffffff",
                  borderRadius: "12px",
                  padding: "16px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)",
                  border: "1px solid rgba(0,0,0,0.06)",
                  margin: "5px 0",
                }}
              >
                {/* Charges et cotisations */}
                <CompactFinancialCardThreeColumn
                  title="Cotisations sociales supplémentaires"
                  valueColumn1={arbitrage100Rem.chargesSup}
                  valueColumn2={arbitrage100Div.chargesSup}
                  valueColumn3={arbitrageOptimum.chargesSup}
                  icon={<FaFileContract />}
                  accentColor="#dc2626"
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                  dataType="uint"
                />
                <CompactFinancialCardThreeColumn
                  title="Prime"
                  valueColumn1={arbitrage100Rem.prime}
                  valueColumn2={arbitrage100Div.prime}
                  valueColumn3={arbitrageOptimum.prime}
                  icon={<FaMoneyBillWave />}
                  accentColor="#2563eb"
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                  dataType="uint"
                />
              </div>
              <div
                style={{
                  background: "#ffffff",
                  borderRadius: "12px",
                  padding: "16px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)",
                  border: "1px solid rgba(0,0,0,0.06)",
                  margin: "5px 0",
                }}
              >
                {/* Résultats fiscaux */}
                <CompactFinancialCardThreeColumn
                  title="Résultat avant IS"
                  valueColumn1={arbitrage100Rem.resAvtIs}
                  valueColumn2={arbitrage100Div.resAvtIs}
                  valueColumn3={arbitrageOptimum.resAvtIs}
                  icon={<FaFileInvoiceDollar />}
                  accentColor="#2563eb"
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                  dataType="uint"
                />
                <CompactFinancialCardThreeColumn
                  title="Impôt sur les sociétés"
                  valueColumn1={arbitrage100Rem.is}
                  valueColumn2={arbitrage100Div.is}
                  valueColumn3={arbitrageOptimum.is}
                  icon={<FaPercentage />}
                  accentColor="#dc2626"
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                  dataType="uint"
                />
                <CompactFinancialCardThreeColumn
                  title="Mise en réserve / dividendes associés"
                  valueColumn1={arbitrage100Rem.reserve}
                  valueColumn2={arbitrage100Div.reserve}
                  valueColumn3={arbitrageOptimum.reserve}
                  icon={<FaWallet />}
                  accentColor="#059669"
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                  dataType="uint"
                />
                <CompactFinancialCardThreeColumn
                  title="Dividendes bruts du dirigeant"
                  valueColumn1={arbitrage100Rem.divBruts}
                  valueColumn2={arbitrage100Div.divBruts}
                  valueColumn3={arbitrageOptimum.divBruts}
                  icon={<FaCoins />}
                  accentColor="#059669"
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                  dataType="uint"
                />
                <CompactFinancialCardThreeColumn
                  title="Régime fiscal des dividendes"
                  valueColumn1={arbitrage100Rem.regime}
                  valueColumn2={arbitrage100Div.regime}
                  valueColumn3={arbitrageOptimum.regime}
                  icon={<FaReceipt />}
                  accentColor="#2563eb"
                  dataType="text"
                />
              </div>
              <div
                style={{
                  background: "#ffffff",
                  borderRadius: "12px",
                  padding: "16px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)",
                  border: "1px solid rgba(0,0,0,0.06)",
                  margin: "5px 0",
                }}
              >
                {/* Revenus et impôts */}
                <CompactFinancialCardThreeColumn
                  title="Revenus nets supplémentaires"
                  valueColumn1={arbitrage100Rem.revPercus}
                  valueColumn2={arbitrage100Div.revPercus}
                  valueColumn3={arbitrageOptimum.revPercus}
                  icon={<FaMoneyBillWave />}
                  accentColor="#059669"
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                  dataType="uint"
                />
                <CompactFinancialCardThreeColumn
                  title="Rémunération déjà perçue sur l'exercice"
                  valueColumn1={arbitrage100Rem.remPercue}
                  valueColumn2={arbitrage100Div.remPercue}
                  valueColumn3={arbitrageOptimum.remPercue}
                  icon={<FaMoneyBillWave />}
                  accentColor="#2563eb"
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                  dataType="uint"
                />
                <CompactFinancialCardThreeColumn
                  title="Autres revenus du foyer"
                  valueColumn1={arbitrage100Rem.autresRevenus}
                  valueColumn2={arbitrage100Div.autresRevenus}
                  valueColumn3={arbitrageOptimum.autresRevenus}
                  icon={<FaGlobe />}
                  accentColor="#059669"
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                  dataType="uint"
                />
                <CompactFinancialCardThreeColumn
                  title="Impôt sur le revenu"
                  valueColumn1={arbitrage100Rem.impot}
                  valueColumn2={arbitrage100Div.impot}
                  valueColumn3={arbitrageOptimum.impot}
                  icon={<FaReceipt />}
                  accentColor="#dc2626"
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                  dataType="uint"
                />
                <CompactFinancialCardThreeColumn
                  title="Cotisations facultatives personnelles"
                  valueColumn1={arbitrage100Rem.cotFacPerso}
                  valueColumn2={arbitrage100Div.cotFacPerso}
                  valueColumn3={arbitrageOptimum.cotFacPerso}
                  icon={<FaFileContract />}
                  accentColor="#2563eb"
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                  dataType="uint"
                />
              </div>
              {/* Résultats finaux - lignes de titre */}
              <HeaderThreeColumn
                libelle="Revenu disponible après impôt"
                icon={<FaHandHoldingUsd className="resultat-header-card-icon" />}
                value1={arbitrage100Rem.revDispo}
                value2={arbitrage100Div.revDispo}
                value3={arbitrageOptimum.revDispo}
              />
              <HeaderThreeColumn
                libelle="Cotisations de retraite productives"
                icon={<FaUser className="resultat-header-card-icon" />}
                value1={arbitrage100Rem.cotProductives}
                value2={arbitrage100Div.cotProductives}
                value3={arbitrageOptimum.cotProductives}
              />
            </div>
          </div>
        </Row>
      </Column>
    </>
  );
};

export default RemExpressArbitragePage;
